import React from 'react';
import { LinkButton } from '@domain-group/fe-co-button';
import * as gtag from 'src/lib/gtag';
import * as styles from './hero.styles';

const Hero: React.FC = () => (
  <div css={styles.container}>
    <div css={styles.contentContainer}>
      <div css={styles.content}>
        <h1>Build your app using Domain APIs.</h1>
        <p>
          Build efficient and innovative products by leveraging agency, listing
          and property data from Domain Group.
        </p>
        <LinkButton
          href="/account/login"
          onClick={() => gtag.tryButtonClick('hero_try_button')}
        >
          Create an account
        </LinkButton>
      </div>
    </div>
  </div>
);

export default Hero;
